import React, { FC, ReactNode } from 'react';

const Box: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="bg-white rounded-lg border border-gray_200 overflow-auto">{children}</div>;
};

export default Box;
